export { default as CopyrightOverlay } from "./CopyrightOverlay";
